
import { PageHeader, TabPanel } from 'components';
import { EditForm } from 'components/EditForm';
import React from 'react';
import { useLocation } from 'react-router-dom';

export const Edit = function () {
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    };
    const headerButtonClickHandler = () => {
        setOpen(true);
    };
    const { pathname } = useLocation()
    return <>

        <PageHeader
            title='Редактировать'
            buttonText="Сохранить"
            buttonOnClick={headerButtonClickHandler}
            variant='outlined'
            back
        />
        <TabPanel height='100%' id={pathname} value={`${pathname}`} key={pathname}>
            <EditForm typeForm='topic' />
        </TabPanel>
    </>
}